import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createSlots as _createSlots, mergeProps as _mergeProps } from "vue"
import _imports_0 from '@/app/ui/assets/svg/exclamation-triangle-red.svg'


const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "px-4" }
const _hoisted_3 = { class: "space-y-6 pb-8" }
const _hoisted_4 = { class: "grid grid-cols-2 gap-y-6 gap-x-6" }
const _hoisted_5 = {
  key: 0,
  class: "plane-form-section w-full border-b border-dashed"
}
const _hoisted_6 = { class: "py-6" }
const _hoisted_7 = /*#__PURE__*/_createVNode("hr", { class: "mt-4 border-gray-lp-400" }, null, -1)
const _hoisted_8 = { class: "grid grid-cols-3 gap-8" }
const _hoisted_9 = { class: "flex flex-row items-start" }
const _hoisted_10 = { class: "flex flex-col" }
const _hoisted_11 = { class: "text-14px font-semibold text-black-lp-300 mb-2" }
const _hoisted_12 = {
  key: 0,
  class: "text-red-lp-300 font-normal pl-1"
}
const _hoisted_13 = { class: "flex flex-row items-center" }
const _hoisted_14 = {
  key: 0,
  class: "text-red-lp-300 font-normal text-14px flex flex-row items-start mt-2 w-4/5"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-5 mr-2",
  alt: "exclamation-triangle"
}, null, -1)
const _hoisted_16 = { class: "mt-1.5" }
const _hoisted_17 = { class: "mt-1.5" }
const _hoisted_18 = /*#__PURE__*/_createVNode("hr", { class: "mt-4 border-gray-lp-400" }, null, -1)
const _hoisted_19 = { class: "grid grid-cols-2 gap-y-6 gap-x-6" }
const _hoisted_20 = { class: "flex flex-row space-x-2 items-center" }
const _hoisted_21 = /*#__PURE__*/_createVNode("span", { class: "text-12px text-black-lp-300" }, " Maksimal Koli pesawat 15 Koli ", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_23 = { class: "space-y-2 pt-2" }
const _hoisted_24 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500" }, [
  /*#__PURE__*/_createTextVNode(" Klik tombol dibawah untuk mengaktifkan kargo. Anda dapat mengubah"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("status kapan saja. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Title = _resolveComponent("Title")!
  const _component_SelectCity = _resolveComponent("SelectCity")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_SelectVendor = _resolveComponent("SelectVendor")!
  const _component_PlaneTransit = _resolveComponent("PlaneTransit")!
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_Icons = _resolveComponent("Icons")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_MultipleSelectCommodity = _resolveComponent("MultipleSelectCommodity")!
  const _component_MultipleSelectProduct = _resolveComponent("MultipleSelectProduct")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Select = _resolveComponent("Select")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!
  const _component_delete_config_popup = _resolveComponent("delete-config-popup")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(_component_DetailLayout, {
      onBack: _ctx.goBack,
      title: `${_ctx.isEdit ? 'Ubah' : 'Buat'} Konfigurasi`,
      "custom-class": "px-0",
      "vertical-separator": false,
      "leave-page-confirmation": _ctx.leavePageConfirmation,
      "onUpdate:leave-page-confirmation": _cache[16] || (_cache[16] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
      onLeavePage: _ctx.onLeavePage,
      verticalSeparator: _ctx.isEdit,
      loading: _ctx.isLoading,
      error: !!_ctx.errorCause,
      errorType: _ctx.errorCause,
      onTryAgain: _ctx.fetchDetailData
    }, _createSlots({
      "top-right": _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          _createVNode(_component_LpButton, {
            "text-color": "white",
            customClass: "w-full py-2.5",
            title: "Simpan",
            onClick: _ctx.onSaveForm,
            disabled: !_ctx.isFormValid
          }, null, 8, ["onClick", "disabled"])
        ])
      ]),
      data: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _createVNode(_component_Title, {
            label: "Rute Awal",
            fontSize: 20,
            class: "mb-4"
          }),
          _createVNode("div", _hoisted_3, [
            _createVNode("div", _hoisted_4, [
              _createVNode(_component_DataWrapper, {
                label: "Kota Asal",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectCity, {
                    status: "active",
                    class: "mt-1.5",
                    placeholder: "Pilih kota asal",
                    modelValue: _ctx.form.originCity,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.originCity = $event)),
                    disabled: _ctx.isEdit
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Kota Tujuan",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectCity, {
                    status: "active",
                    class: "mt-1.5",
                    placeholder: "Pilih kota tujuan",
                    modelValue: _ctx.form.destinationCity,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.form.destinationCity = $event)),
                    disabled: _ctx.isEdit
                  }, null, 8, ["modelValue", "disabled"])
                ]),
                _: 1
              }),
              _createVNode(_component_DataWrapper, {
                label: "Transportasi Moda",
                asterisk: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomDropdown, {
                    options: _ctx.optionTransportation,
                    onSelect: _ctx.selectTransportation,
                    placeholder: "Pilih transportasi",
                    isCustomWidth: "",
                    selectedItem: _ctx.form.transportationType,
                    class: "w-full mt-1.5",
                    isDisabled: _ctx.isEdit
                  }, null, 8, ["options", "onSelect", "selectedItem", "isDisabled"])
                ]),
                _: 1
              }),
              _withDirectives(_createVNode(_component_DataWrapper, { label: "Nama Vendor" }, {
                default: _withCtx(() => [
                  _createVNode(_component_SelectVendor, {
                    status: "active",
                    class: "mt-1.5",
                    placeholder: "Pilih vendor",
                    modelValue: _ctx.form.vendor,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.vendor = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }, 512), [
                [_vShow, false]
              ])
            ]),
            (_ctx.isPlane)
              ? (_openBlock(), _createBlock("div", _hoisted_5, [
                  _createVNode(_component_Title, {
                    label: "Input Waktu dan Penerbangan",
                    fontSize: 20
                  }),
                  _createVNode("div", _hoisted_6, [
                    _createVNode(_component_PlaneTransit, {
                      schedules: _ctx.schedulePlanes,
                      "onUpdate:schedules": _cache[4] || (_cache[4] = ($event: any) => (_ctx.schedulePlanes = $event)),
                      isDefaultValue: _ctx.isEdit,
                      originCity: _ctx.form.originCity,
                      destinationCity: _ctx.form.destinationCity
                    }, null, 8, ["schedules", "isDefaultValue", "originCity", "destinationCity"])
                  ])
                ]))
              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                  _hoisted_7,
                  _createVNode(_component_Title, {
                    label: "Waktu Cut Off",
                    fontSize: 20
                  }),
                  _createVNode("div", _hoisted_8, [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filterCutOffTimeByStatus, (item, index) => {
                      return (_openBlock(), _createBlock(_Fragment, { key: item }, [
                        _createVNode("div", _hoisted_9, [
                          _createVNode("div", _hoisted_10, [
                            _createVNode("span", _hoisted_11, [
                              _createTextVNode(" Cycle " + _toDisplayString(index + 1) + " ", 1),
                              (index === 0)
                                ? (_openBlock(), _createBlock("span", _hoisted_12, " * "))
                                : _createCommentVNode("", true)
                            ]),
                            _createVNode("div", _hoisted_13, [
                              _createVNode(_component_Datepicker, {
                                modelValue: item.ctTime,
                                "onUpdate:modelValue": [($event: any) => (item.ctTime = $event), 
                          value => _ctx.formatCutOffTimeValue({ value, index })
                        ],
                                showDatePicker: false,
                                showTimePicker: "",
                                manualInput: "",
                                showIcon: "",
                                showChevron: false,
                                placeholder: "06:00",
                                customClass: "",
                                isError: item.isError,
                                setDefaultDate: _ctx.isEdit
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "isError", "setDefaultDate"]),
                              (_ctx.filterCutOffTimeByStatus.length > 1)
                                ? (_openBlock(), _createBlock(_component_Icons, {
                                    key: 0,
                                    name: "trash-concentrated",
                                    class: "cursor-pointer w-6 ml-4 text-red-lp-100",
                                    onClick: ($event: any) => (_ctx.deleteCutOffTime(index))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ]),
                            (item.isError)
                              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                  _hoisted_15,
                                  _createTextVNode(" Jam cycle " + _toDisplayString(index + 1) + " harus lebih dari cycle " + _toDisplayString(index), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ])
                        ]),
                        (
                    index === _ctx.filterCutOffTimeByStatus.length - 1 && index < 4
                  )
                          ? (_openBlock(), _createBlock("div", {
                              key: 0,
                              class: 
                    `flex ${
                      _ctx.haveErrorCutOffTime ? 'items-start pt-6' : 'items-end'
                    }`
                  
                            }, [
                              _createVNode(_component_LpButton, {
                                title: "Cycle",
                                textColor: "white",
                                iconLeft: "plus-square",
                                iconColor: "white",
                                iconV2: "",
                                onClick: _ctx.addCutOffTime,
                                disabled: item.isError
                              }, null, 8, ["onClick", "disabled"])
                            ], 2))
                          : _createCommentVNode("", true)
                      ], 64))
                    }), 128))
                  ])
                ], 64))
          ]),
          _createVNode(_component_DataWrapper, {
            label: "Klien Induk",
            optional: "",
            class: "mb-6"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_16, [
                _createVNode(_component_SelectSearch, {
                  onFilter: _ctx.onSearchClientName,
                  onFocus: _ctx.onSearchClientName,
                  onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.clientBranchValue = [])),
                  isLoading: _ctx.isLoadingClientPartner,
                  options: _ctx.mappedDataClient,
                  keyName: "display",
                  keyValue: "id",
                  placeholder: "Ketik atau pilih klien induk",
                  modelValue: _ctx.clientValue,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.clientValue = $event))
                }, null, 8, ["onFilter", "onFocus", "isLoading", "options", "modelValue"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_DataWrapper, {
            label: "Klien Cabang",
            optional: "",
            class: "mb-6"
          }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_17, [
                _createVNode(_component_MultipleSelectSearch, {
                  "modal-title": "Klien Cabang",
                  "option-name": "kota",
                  onFocus: _ctx.filterClientBranch,
                  onFilter: _ctx.filterClientBranch,
                  onChange: _ctx.onChangeClientBranch,
                  options: _ctx.clientBranchOptions,
                  modelValue: _ctx.clientBranchValue,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.clientBranchValue = $event)),
                  keyName: "display",
                  keyValue: "id",
                  placeholder: "Ketik atau pilih klien cabang",
                  isLoading: _ctx.isLoadingClientPartner,
                  showReset: "",
                  "able-to-delete-in-modal": ""
                }, null, 8, ["onFocus", "onFilter", "onChange", "options", "modelValue", "isLoading"])
              ])
            ]),
            _: 1
          }),
          _hoisted_18,
          _createVNode(_component_Title, {
            label: "Detail Produk",
            fontSize: 20,
            class: "mb-4"
          }),
          _createVNode("div", _hoisted_19, [
            _createVNode(_component_DataWrapper, {
              label: "Tipe Komoditi",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultipleSelectCommodity, {
                  isCommodityGroup: true,
                  status: "active",
                  class: "mt-1.5",
                  placeholder: "Pilih tipe komoditi",
                  modelValue: _ctx.form.commodities,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.form.commodities = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Tipe Produk",
              optional: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_MultipleSelectProduct, {
                  status: "active",
                  class: "mt-1.5",
                  placeholder: "Pilih tipe produk",
                  modelValue: _ctx.form.products,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.form.products = $event))
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Maksimum Koli",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.maximumPieces,
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.form.maximumPieces = $event)),
                  format: _ctx.formatInputNumber,
                  onChange: _ctx.onChangeMaxPieces,
                  placeholder: "Masukkan jumlah maksimum koli",
                  error: !_ctx.isValidMaxPieces,
                  isErrorIconCaption: false,
                  isErrorIconInput: false
                }, null, 8, ["modelValue", "format", "onChange", "error"]),
                _createVNode("div", _hoisted_20, [
                  _createVNode(_component_Icons, {
                    name: "info",
                    class: "w-5 text-black-lp-300"
                  }),
                  _hoisted_21
                ])
              ]),
              _: 1
            }),
            (_ctx.isPlane)
              ? (_openBlock(), _createBlock(_component_DataWrapper, {
                  key: 0,
                  label: "Tipe Produk Kargo",
                  optional: ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Select, {
                      onOpenSelect: _ctx.onOpenSelectCargoProduct,
                      onCloseSelect: _ctx.onCloseSelectCargoProduct,
                      isOpenMenu: _ctx.isOpenSelectCargoProduct,
                      value: _ctx.form.cargoProduct,
                      onChooseSelect: _ctx.onSelectCargoProduct,
                      dataSelect: _ctx.listProductCargo,
                      customClass: "w-full",
                      class: "w-full whitespace-no-wrap my-2 z-10"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "dataSelect"])
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_DataWrapper, {
              label: "Minimum Berat(kg)",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.minimumWeight,
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.form.minimumWeight = $event)),
                  format: _ctx.formatFloat,
                  error: _ctx.isValidWeightVolume(_ctx.form.minimumWeight),
                  errorCaption: "Jumlah minimum berat tidak boleh kurang dari 0,1 kg",
                  placeholder: "Masukkan jumlah berat minimum"
                }, null, 8, ["modelValue", "format", "error"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Maksimum Berat(kg)",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.maximumWeight,
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.form.maximumWeight = $event)),
                  format: _ctx.formatFloat,
                  error: _ctx.isValidWeightVolume(_ctx.form.maximumWeight),
                  errorCaption: "Jumlah maksimum berat tidak boleh kurang dari 0,1 kg",
                  placeholder: "Masukkan jumlah berat maksimum"
                }, null, 8, ["modelValue", "format", "error"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Minimum Volume(kg)",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.minimumVolume,
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.form.minimumVolume = $event)),
                  format: _ctx.formatFloat,
                  error: _ctx.isValidWeightVolume(_ctx.form.minimumVolume),
                  errorCaption: "Jumlah minimum volume tidak boleh kurang dari 0,1 kg",
                  placeholder: "Masukkan jumlah volume minimum"
                }, null, 8, ["modelValue", "format", "error"])
              ]),
              _: 1
            }),
            _createVNode(_component_DataWrapper, {
              label: "Maksimum Volume(kg)",
              asterisk: ""
            }, {
              default: _withCtx(() => [
                _createVNode(_component_LpInput, {
                  modelValue: _ctx.form.maximumVolume,
                  "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.form.maximumVolume = $event)),
                  format: _ctx.formatFloat,
                  error: _ctx.isValidWeightVolume(_ctx.form.maximumVolume),
                  errorCaption: "Jumlah maksimum volume tidak boleh kurang dari 0,1 kg",
                  placeholder: "Masukkan jumlah volume maksimum"
                }, null, 8, ["modelValue", "format", "error"])
              ]),
              _: 1
            })
          ]),
          _hoisted_22,
          _createVNode(_component_DataWrapper, { label: "Status" }, {
            default: _withCtx(() => [
              _createVNode("div", _hoisted_23, [
                _hoisted_24,
                _createVNode(_component_Toggle, {
                  modelValue: _ctx.form.status,
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.form.status = $event)),
                  textActive: "Aktif",
                  textInactive: "Tidak Aktif"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _: 1
          })
        ])
      ]),
      _: 2
    }, [
      (_ctx.isEdit)
        ? {
            name: "sub-data",
            fn: _withCtx(() => [
              _createVNode(_component_DataWrapper, {
                label: "Status",
                value: _ctx.form.status ? 'Aktif' : 'Tidak Aktif',
                customStyleValue: 
          `max-w-max font-medium rounded-full px-2 py-0 ${
            _ctx.form.status ? 'bg-green-lp-300' : 'bg-red-300'
          } ${_ctx.form.status ? 'text-green-lp-200' : 'text-red-lp-200'} capitalize`
        
              }, null, 8, ["value", "customStyleValue"]),
              _createVNode(_component_DataWrapper, {
                label: "Tanggal Dibuat",
                value: _ctx.formatDate(_ctx.form.createdAt),
                caption: _ctx.form.createdBy
              }, null, 8, ["value", "caption"]),
              _createVNode(_component_DataWrapper, {
                label: "Tanggal Diubah",
                value: _ctx.formatDate(_ctx.form.updatedAt),
                caption: _ctx.form.updatedBy
              }, null, 8, ["value", "caption"]),
              (_ctx.isEditAble && !_ctx.form.status)
                ? (_openBlock(), _createBlock(_component_LpButton, {
                    key: 0,
                    title: "Hapus Konfigurasi",
                    onClick: _ctx.deleteConfig,
                    "custom-class": "w-44",
                    textColor: "red-lp-300",
                    iconLeft: "trash-red",
                    outline: ""
                  }, null, 8, ["onClick"]))
                : _createCommentVNode("", true)
            ])
          }
        : undefined
    ]), 1032, ["onBack", "title", "leave-page-confirmation", "onLeavePage", "verticalSeparator", "loading", "error", "errorType", "onTryAgain"]),
    (_ctx.deleteConfigModal)
      ? (_openBlock(), _createBlock(_component_delete_config_popup, _mergeProps({
          key: 0,
          modelValue: _ctx.deleteConfigModal,
          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.deleteConfigModal = $event))
        }, _ctx.configSelected), null, 16, ["modelValue"]))
      : _createCommentVNode("", true)
  ], 64))
}